import { Pipe, PipeTransform } from '@angular/core';
import { ActionLog } from '../models/actionLog';

@Pipe({
  name: 'logFilter'
})
export class LogFilterPipe implements PipeTransform {

  transform(actionLogs: ActionLog[], filterText: string) {
    if (!actionLogs) return actionLogs;
    if (actionLogs.length === 0 || filterText === "") {
      return actionLogs;
    } else {
      return actionLogs.filter((actionlog) => {
        return actionlog.entityName.toLowerCase().includes(filterText.toLowerCase());
      })
    }
  }

}
